import type { SupportedActivity } from '../athlete-onboarding/types';

export type ExtraFieldType = 'text' | 'tel' | 'select' | 'multiselect' | 'number';

export interface ExtraFieldConfig {
    key: string;
    label: string;
    type: ExtraFieldType;
    required: boolean;
    placeholder?: string;
    options?: string[];
}

export interface FormConfig {
    extra_fields: ExtraFieldConfig[];
}

export interface ImageData {
    avif: string | null;
    webp: string | null;
    jpeg: string | null;
    fallback: string | null;
    alt: string | null;
}

export interface HeardAboutOption {
    value: string;
    label: string;
    followUp: { label: string; placeholder: string } | null;
}

export interface PageData {
    csrfToken: string;
    applicationId: string;
    heardAboutOptions: HeardAboutOption[];
    copy: string | null;
    defaultImage: ImageData | null;
    image: ImageData | null;
    applicationError: 'not_found' | 'error' | null;
    formConfig: FormConfig | null;
    referral_code: string | null;
    backgroundImage: string | null;
    supportedActivities?: SupportedActivity[];
}

export interface OtpState {
    otp_id: string;
}

export interface VerifiedState {
    verified_token: string;
    verified_at: number;
}

export enum SubmissionStatus {
    Submitted = 'submitted',
    Pending = 'pending',
    CanReapply = 'can_reapply',
    ApprovedPendingActivation = 'approved_pending_activation',
    AlreadyActivated = 'already_activated',
}
